import { render, staticRenderFns } from "./BumpersList.vue?vue&type=template&id=f96dec1e"
import script from "./BumpersList.vue?vue&type=script&lang=js"
export * from "./BumpersList.vue?vue&type=script&lang=js"
import style0 from "./BumpersList.vue?vue&type=style&index=0&id=f96dec1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports